import React from 'react';
import './error-layout.css';

interface ErrorLayoutProps {
  children: React.ReactNode;
}

/**
 * Shell layout for error pages.
 * Provides a full-viewport centered container, analogous to MainLayout for the main app.
 */
export const ErrorLayout: React.FC<ErrorLayoutProps> = ({ children }) => {
  return <div className="cb-error-shell">{children}</div>;
};
